import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import every from 'lodash/every';
import values from 'lodash/values';
import compact from 'lodash/compact';
import { mapGetters } from 'vuex';
import StoreAvailability from '~/services/store';
import _validateZipcode from '~/helpers/zipcode-validator-helper';
import LineOnSideHeader from '~/components/atoms/LineOnSideHeader.vue';
import TextField from '~/components/atoms/TextField.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-down.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/loupe.svg';

var MdmModal = function MdmModal() {
  return import(
  /* webpackChunkName: "modal" */
  '~/components/atoms/Global/MdmModal.vue');
};

var MANDATORY_FIELDS = ['zipcode'];
export default {
  name: 'StoreAvailabilityModal',
  components: {
    MdmModal: MdmModal,
    LineOnSideHeader: LineOnSideHeader,
    TextField: TextField
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      page: 1,
      stores: null,
      values: {
        zipcode: null
      },
      pendingRequest: false,
      formSuccess: false,
      showServerError: false,
      submitted: false,
      errors: {
        zipcode: false,
        zipcodeFormat: false
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    zipcodeErrorMessage: function zipcodeErrorMessage() {
      return this.errors.zipcodeFormat ? this.$t('field_zip_code_invalid_error') : '';
    }
  }),
  watch: {
    values: {
      handler: function handler() {
        if (!this.submitted) {
          return;
        }

        this.validateMandatoryFields();
      },
      deep: true
    },
    'values.zipcode': function watchZipcode() {
      this.errors.zipcodeFormat = false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      if (window.woosmap) {
        var provider = new window.woosmap.ZipCodeProvider();
        _this.values.zipcode = provider.getZipCode();
      }
    }, 500);
  },
  methods: {
    validateZipcode: function validateZipcode() {
      var isoMarket = this.locale.iso.slice(-2);
      this.errors.zipcodeFormat = this.values.zipcode ? !_validateZipcode(this.values.zipcode, isoMarket) : false;
    },
    validateMandatoryFields: function validateMandatoryFields() {
      var _this2 = this;

      MANDATORY_FIELDS.forEach(function (field) {
        _this2.errors[field] = !_this2.values[field];
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.submitted = true;
      this.validateMandatoryFields();
      this.validateZipcode();

      if (every(this.errors, function (field) {
        return !field;
      })) {
        this.pendingRequest = true;
        this.page = 1;
        var stockClasses = {
          shop_stock_available: 'available',
          shop_stock_limited: 'limited',
          shop_stock_unavailable: 'unavailable'
        };
        StoreAvailability(this.$store, this.product.reference, this.values.zipcode).then(function (_ref) {
          var shops = _ref.shops;
          _this3.stores = values(shops).map(function (e) {
            return {
              id: e.id,
              city: e.city,
              address: compact([e.address, e.address2, e.address_complement]),
              phone: e.phone,
              distance: e.dist,
              distanceLabel: "".concat(e.dist, " km"),
              stockStatus: e.stock_status_label,
              stockClass: stockClasses[e.stock_status]
            };
          });
          _this3.pendingRequest = false;
          _this3.submitted = false;
        });
      }
    },
    more: function more() {
      this.page += 1;
    }
  }
};